import type { IconProps } from '../types/IconProps.ts';
export const LogIn: IconProps = {
    name: 'LogIn',
    children: [
        `<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />`,
        `<path d="m10 7 5.08 4.23a1 1 0 0 1 0 1.54L10 17M3 12h11" />`,
    ]
};